<template>
<card :image="true" :footer="true" class="user-details">
<template slot="image">
  <figure class="image is-5by1">
    <img :src="coverImage" alt="Profile Header" class="cover-profile">
    <button v-if="isWidget" class="button" @click="goBack" >
      <hv-image size="" :is-rounded="false" :src="favouriteStarUrl">
      </hv-image>
    </button>
    <dropdown  :is-right='true' :is-active.sync="dropdownActive">
      <button v-if="editable" class="edit-btn"
              @click.prevent="editProfileClicked">
        {{this.$t('profile.edit')}}
      </button>
<!--      <template slot="dropdown-content">-->
<!--        <a v-if="editable" class="dropdown-item" @click.prevent="editProfileClicked">-->
<!--          {{this.$t('profile.editProfile')}}-->
<!--        </a>-->
<!--        <hr class="dropdown-divider">-->
<!--        <a v-if="showddOptions" class="dropdown-item"-->
<!--          v-clipboard:copy="profileUrl"-->
<!--          v-clipboard:success="onCopy"-->
<!--          v-clipboard:error="onError">-->
<!--          {{this.$t('profile.copyProfileURL')}}-->
<!--          <small class="copy-lbl" v-if="copied">{{this.$t('profile.copied')}}!</small>-->
<!--        </a>-->
<!--      </template>-->
    </dropdown>
  </figure>
</template>
<div class="flex-center">
  <user-image :user="user" :brandImageUrl="brandImageUrl" class="border-white-3px" />
</div>
<div class="media">
  <template v-if="company">
    <div v-if="isCompanyLink && company" class="media-content hirer">
      <p v-if="companyName" class="title is-4">{{ companyName }}</p>
      <p class="is-cursor-pointer" @click="openCompanyUrl()" v-if="companyDetails">{{ companyDetails }}</p>
      <p v-if="location" class="m-t-8">{{ location }}</p>
    </div>
    <div v-else-if="company" class="media-content hirer" >
      <p v-if="companyName" class="title is-4">{{ companyName }}</p>
      <p v-if="companyDetails">{{ companyDetails }}</p>
      <p v-if="location" class="m-t-8">{{ location }}</p>
    </div>
  </template>
  <template v-else>
    <div class="media-content" v-if="user">
      <p class="title is-4">{{ fullName }}</p>
      <p>{{ workDetails }}</p>
      <p class="m-t-8">{{ location }}</p>
      <p class="m-t-8">{{ profileStatus }}</p>
      <p class="m-t-8" v-if="user.talentLayerId">Talent Layer ID: <strong> {{ user.talentLayerId }}</strong></p>
    </div>
  </template>
</div>
<template slot="footer">
  <p class="bio" v-if="bio">
    <text-block>{{ bio }}</text-block>
  </p>
  <p class="bio" v-else-if="editable">
    <a @click.prevent="addBioClicked">
    {{this.$t('profile.addShortBio')}}</a> {{this.$t('profile.toYourProfile')}}
  </p>
</template>
</card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Card from '@/components/general/card'
import UserImage from '@/components/general/user-image'
import Dropdown from '@/components/general/dropdown'
import TextBlock from '@/components/general/text-block'
import FavouriteStar from '@/assets/back-arrow.svg'
import HvImage from '@/components/general/image'
import _ from 'lodash'

export default {
  components: { Card, UserImage, Dropdown, TextBlock, HvImage },
  props: {
    user: {
      type: Object,
      default: () => null
    },
    company: {
      type: Object,
      default: () => null
    },
    editable: {
      type: Boolean,
      required: true
    },
    brandImageUrl: {
      type: String,
      default: () => null
    },
    coverImageUrl: {
      type: String,
      default: () => null
    },
    showDropdown: {
      type: Boolean,
      default: true
    },
    hirer: {
      type: Boolean,
      default: false
    },
    isCompanyLink: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters('users', [
      'coverImageForUser',
      'userid'
    ]),
    ...mapState('jobseekerProfiles', {
      profile: 'jobseekerProfile'
    }),
    ...mapGetters([
      'getJobseekerProfileLink',
      'getHirerProfileLink'
    ]),
    ...mapGetters('companies', [
      'detailInfo'
    ]),
    favouriteStarUrl () {
      return FavouriteStar
    },
    isWidget () {
      return !!this.$route.meta.hasOwnProperty('widgetMode')
    },
    profileStatus () {
      if (!this.profile) {
        return ''
      }
      return this.profile && this.profile.isPublic ? 'Profile: Public' : 'Profile: Private'
    },
    workDetails () {
      const user = this.user
      if (user.role && user.companyName) {
        return `${user.role} • ${user.companyName}`
      } else if (user.role) {
        return user.role
      } else {
        return ''
      }
    },
    location () {
      if (this.user || this.company) {
        const companyLocations = _.get(this.company, 'locations')
        const userLocation = _.get(this.user, 'locationTitle')
        return _.join(companyLocations) || userLocation
      }
    },
    bio () {
      if (this.user || this.company) {
        const companyBio = _.get(this.company, 'bio')
        const userBio = _.get(this.user, 'bio')
        return companyBio || userBio
      }
    },
    fullName () {
      const user = this.user
      return `${user.firstName} ${user.lastName}`
    },
    coverImage () {
      return this.coverImageUrl || this.coverImageForUser(this.user)
    },
    profileUrl () {
      if (this.hirer) {
        const companyId = _.get(this.company, 'id') || _.get(this.company, 'companyId')
        return `${this.getHirerProfileLink}/${companyId}`
      }
      return `${this.getJobseekerProfileLink}/${this.user.id}`
    },
    companyName () {
      const company = this.company || this.detailInfo
      if (company) {
        return company.name
      }
      return ''
    },
    companyDetails () {
      const company = this.company || this.detailInfo
      if (!company) return null
      let title = ''
      if (company.category && company.category !== 'undefined') {
        title = company.category
      }
      if (company.category && company.domain && company.category !== 'undefined') {
        title += ` • `
      }
      title += company.domain || ''
      return title
    },
    showddOptions () {
      if (this.hirer) return true
      if (this.user) return true
    }
  },
  methods: {
    ...mapActions('companies', [
      'getDetail'
    ]),
    openCompanyUrl () {
      window.open(`https://www.${this.company.domain}`, '_blank')
    },
    goBack () {
      this.$router.go(-1)
    },
    addBioClicked () {
      this.$emit('edit-profile')
    },
    editProfileClicked () {
      this.dropdownActive = false
      this.$emit('edit-profile')
    },
    logoutClicked () {
      this.$emit('logout')
    },
    toggleActive () {
      this.dropdownActive = !this.dropdownActive
    },
    onCopy () {
      this.copied = true
      const self = this
      setTimeout(_ => {
        self.copied = false
      }, 3000)
    },
    onError (e) {
      self.copied = false
    }
  },
  data () {
    return {
      dropdownActive: false,
      copied: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.user-details .card-content {
  background-color: black;
}

.card-footer p {
  padding: 1rem;
}

.card-footer p {
  padding: 1rem;
  text-align: center;
  width: 100%;
  color: #111;
}

.card-image figure {
  border-top-left-radius: 20px;
}

.card-content figure {
  margin-top: -4.5rem;
}

.card-content .media-content {
  text-align: center;
  margin-top: 16px;

  & .title {
    margin-bottom: 16px;
  }
}

.image.is-centered {
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -45px;
}

.image.is-circular {
  border: solid white 3px;
}

.image.is-5by1 {
  padding-top: 18.5%;

  .dropdown {
    float: right;
    margin-top: calc(-18.5% + 15px);
    margin-right: 15px;
  }

  .button {
    float: left;
    margin-top: calc(-18.5% + 15px);
    margin-left: 15px;
    font-weight: normal !important;
    text-transform: none;
  }

  .mr{
    margin-right: 10px;
  }

  & > img {
    height: 100%;
    width: 100%;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }
}

.button.is-active {
  color: $brand-primary;
  border-color: $brand-primary;
}

.media-content {
  p:last-child {
    margin-top: 0.5rem;
  }
}

p.bio {
  line-height: 1.5;
}

.copy-lbl {
  font-size: 7px;
  background: #ddd;
  padding: 2px 3.5px;
  border-radius: 2.6px;
  letter-spacing: 1px;
  position: relative;
  top: -2px;
  left: 2px;
}

.edit-btn{
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #000000;
  cursor: pointer;
  background: #FFFFFF;
  border: 0.5px solid #DDDDDD;
  border-radius: 4px;
  width: 37px;
  height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/user-details-card.vue